<h1 mat-dialog-title>Plantillas</h1>
<div class="table-scroll">
    <table mat-table class="full-width" [dataSource]="dataSource">
        <tr mat-header-row class="table-header" *matHeaderRowDef="columns"></tr>
        <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: columns;"></tr>

        <ng-container matColumnDef="Select">
            <th mat-header-cell class="table-header" *matHeaderCellDef> </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                <mat-checkbox class="margin-right-medium" (change)="checkChange(element.StudyReportId)"></mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateTime">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Fecha turno </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.DateTime | date:'dd/MM/yyyy HH:mm' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="DeliveryDate">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Fecha entrega </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.DeliveryDate | date:'dd/MM/yyyy HH:mm' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Protocol">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Protocolo </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.Protocol }}
            </td>
        </ng-container>

        <ng-container matColumnDef="PatientFullName">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Paciente </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.PatientFullName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="PracticeName">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Práctica </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.PracticeName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="StudyReportRegion">
            <th mat-header-cell class="table-header" *matHeaderCellDef> Región </th>
            <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.StudyReportRegion }}
            </td>
        </ng-container>

    </table>
</div>
<div class="clearfix">
    <div class="pull-right margin-top-small">
        <button mat-button type="button" (click)="unification()">Unificar e informar</button>
        <button mat-button type="button" (click)="noUnification()">Solo informar</button>
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
</div>